import React, { useMemo } from 'react';
import {
  Menu,
  MenuButton,
  MenuItemRadio,
  MenuList,
  MenuPopover,
  MenuTrigger,
  MenuProps,
  tokens,
} from '@fluentui/react-components';
import {
  ChevronDown16Regular,
  FluentIcon,
} from '@fluentui/react-icons';

import { useIsReadOnlyUser } from './use-is-read-only-user';

interface IMenuItemConfig {
  icon?: FluentIcon;
  iconColor?: string;
  text: string;
  value: string;
}

export interface IDropdownMenuButtonProps {
  checkedValue: string;
  onChange: MenuProps['onCheckedValueChange'];
  menuItemConfigs: IMenuItemConfig[];
  buttonAriaLabel: string;
}

export const DropdownMenuButton: React.FunctionComponent<IDropdownMenuButtonProps> = ({
  checkedValue,
  onChange,
  menuItemConfigs,
  buttonAriaLabel,
}: IDropdownMenuButtonProps) => {
  const isReadOnly = useIsReadOnlyUser();

  const checkedValues = useMemo<
    Record<string, string[]>
  >(() => ({
    key: [checkedValue],
  }), [checkedValue]);

  const menuItems = useMemo(() => menuItemConfigs.map(menuItemConfig => (
    <MenuItemRadio
      icon={
        menuItemConfig.icon ? <menuItemConfig.icon
          style={{ color: menuItemConfig.iconColor ? menuItemConfig.iconColor : tokens.colorNeutralForeground3 }}
        /> : null
      }
      value={menuItemConfig.value}
      name="key"
      key={menuItemConfig.value}
      className="ba-status-summary-card-menu-list-item"
    >
      {menuItemConfig.text}
    </MenuItemRadio>
  )), [menuItemConfigs]);

  return (
    <Menu checkedValues={checkedValues} onCheckedValueChange={onChange}>
      <MenuTrigger disableButtonEnhancement>
        <MenuButton
          appearance="subtle"
          icon={<ChevronDown16Regular />}
          className="ba-status-summary-card-menu-button"
          aria-label={buttonAriaLabel}
          disabled={isReadOnly}
        />
      </MenuTrigger>

      <MenuPopover>
        <MenuList className="ba-status-summary-card-menu-list">
          {menuItems}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
